import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 419px);
`;
